import { render, staticRenderFns } from "./BasicLever.vue?vue&type=template&id=4d22002f&scoped=true&"
import script from "./BasicLever.vue?vue&type=script&lang=js&"
export * from "./BasicLever.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d22002f",
  null
  
)

export default component.exports